module.exports = __webpack_public_path__ + "static/media/PM136.b8a2694c.png";